import { render, staticRenderFns } from "./dict-select.vue?vue&type=template&id=2c42204c&scoped=true&lang=pug"
import script from "./dict-select.vue?vue&type=script&lang=js"
export * from "./dict-select.vue?vue&type=script&lang=js"
import style0 from "./dict-select.vue?vue&type=style&index=0&id=2c42204c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c42204c",
  null
  
)

export default component.exports